import { createSvgIconComponent } from "../utils";
export var IconPhone = createSvgIconComponent({
  viewBox: "0 0 16 16",
  fill: "currentColor",
  fillRule: "inherit",
  clipRule: "evenodd",
  path: "m4.978.847 1.345 3.332a.531.531 0 0 1-.144.625l-1.6 1.476a.544.544 0 0 0-.113.625 12.267 12.267 0 0 0 4.633 4.62.57.57 0 0 0 .694-.112L11.15 9.95a.563.563 0 0 1 .625-.144l3.37 1.332a.556.556 0 0 1 .345.625l-.494 2.126a2.045 2.045 0 0 1-2.208 1.6 13.376 13.376 0 0 1-5.14-1.707 15.005 15.005 0 0 1-5.421-5.389 12.884 12.884 0 0 1-1.72-5.24 2.013 2.013 0 0 1 1.576-2.137L4.328.509a.57.57 0 0 1 .625.338h.025Z"
});